import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Contains Survey Configuration: scenario-scoped configuration records used to drive Survey Configuration pages and future survey setup behavior.',
    name: 'Space Survey Configurations',
    partialId: PartialId.Standard.create('space_survey_config'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
